<div class="grid mt-2">
    <div class="col-12 lg:col-6" style="padding: 0;">
      <div class="col-12 flex align-items-center align-content-center" style="padding: 0;">
        <div class="col-6 pt-0">
          <div class="stat-vertical">
            <span class="stat-title">
              {{'StockStats.TotalStock' | translate}}
            </span>
            <span  class="stat-number">
              {{stock.totalPalletStock}}
            </span>
          </div>
        </div>
        <div class="col-6 pl-0 pt-0">
          <div class="stat-vertical">
            <span class="stat-title">
              {{'StockStats.TotalCases' | translate}}
            </span>
            <span class="stat-number">
              {{stock.totalBoxes}}
            </span>
          </div>
        </div>
        <div class="col-6 pl-0 pt-0">
          <div class="stat-vertical">
            <span class="stat-title">
              {{'StockStats.TotalContainers' | translate}}
            </span>
            <span class="stat-number">
              {{stock.totalContainers}}
            </span>
          </div>
        </div>
        <div class="col-6 pt-0">
          <div class="stat-vertical">
            <span class="stat-title">
              {{'StockStats.TotalPallets' | translate}}
            </span>
            <span  class="stat-number">
              {{stock.totalPallets}}
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 flex justify-content-start" style="padding: 0;">
        <div class="col-6 pl-0 pb-0">
          <div class="stat-vertical-select">
            <span class="stat-title">
              {{'StockStats.TotalStockUsed' | translate}}
            </span>
            <span  class="stat-number">
              {{stock.totalPalletStockUsed}}
            </span>
          </div>
        </div>
        <div class="col-6 pb-0">
          <div class="stat-vertical-select">
            <span class="stat-title">
              {{'StockStats.TotalCasesUsed' | translate}}
            </span>
            <span  class="stat-number">
              {{stock.totalBoxesUsed}}
            </span>
          </div>
        </div>
        <div class="col-6 pb-0">
          <div class="stat-vertical-select">
            <span class="stat-title">
              {{'StockStats.TotalContainersUsed' | translate}}
            </span>
            <span  class="stat-number">
              {{stock.totalContainersUsed}}
            </span>
          </div>
        </div>
        <div class="col-6 pb-0">
          <div class="stat-vertical-select">
            <span class="stat-title">
              {{'StockStats.TotalPalletsUsed' | translate}}
            </span>
            <span  class="stat-number">
              {{stock.totalPalletsUsed}}
            </span>
          </div>
        </div>
      </div>
    </div>
</div>

